import React from 'react';
import { AlertTriangle, ArrowUpRight, Lightbulb, Check } from 'lucide-react';
import { sources } from '@/data/ekg';

export const ClinicalNotes = ({ pattern }) => (
  <aside className="ekg-notes" data-testid="ekg-clinical-notes" aria-label={`Merkhilfe ${pattern.title}`}>
    <section className="pb-6 border-b">
      <h3 className="text-sm font-semibold mb-4">Erkennungsmerkmale</h3>
      <ul className="space-y-3">
        {pattern.features.map((feature, index) => <li key={feature} className="flex gap-2.5 text-sm leading-relaxed" data-testid={`ekg-feature-${index}`}>
          <Check size={15} className="text-teal-700 shrink-0 mt-1" aria-hidden="true" /><span>{feature}</span>
        </li>)}
      </ul>
    </section>
    <section className="py-5 border-b">
      <h3 className="text-sm font-semibold mb-3 flex items-center gap-2"><Lightbulb size={17} className="text-teal-700" />Merksatz</h3>
      <p className="text-sm font-medium leading-relaxed text-teal-900" data-testid="ekg-mnemonic">{pattern.mnemonic}</p>
    </section>
    <section className="py-5 border-b">
      <h3 className="text-sm font-semibold mb-3 flex items-center gap-2"><AlertTriangle size={17} className="text-amber-700" />Nicht verwechseln</h3>
      <p className="text-sm leading-relaxed text-muted-foreground" data-testid="ekg-caution">{pattern.caution}</p>
    </section>
    <section className="pt-5">
      <h3 className="text-xs font-semibold text-muted-foreground mb-3">Fachquellen</h3>
      <ul className="space-y-3">{pattern.sources.map(id => <li key={id}>
        <a href={sources[id].url} target="_blank" rel="noopener noreferrer" className="text-xs text-teal-800 hover:underline flex items-start gap-1.5" data-testid={`ekg-source-${id}`}>
          <span>{sources[id].label}</span><ArrowUpRight size={13} className="shrink-0" /><span className="sr-only"> (neuer Tab)</span>
        </a>
      </li>)}</ul>
    </section>
  </aside>
);